import React from "react";
import "./Receipt.css";

export default function Receipt() {
  return (
    <div
      style={{
        display: "flex",
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "40px",
        fontWeight: "bold",
      }}
    >
      hi
    </div>
  );
}
